/* QUANTICA · Carrusel generico.

   Lo usan la seccion de reseñas y la de Creators. Nacio con las reseñas y se
   volvio generico cuando Creators pidio lo mismo: una fila que no abra una
   fila nueva al agregar un elemento. Lo unico propio de cada seccion son los
   estilos de la pista y de las tarjetas; el comportamiento es este.

   NO MUEVE EL CARRUSEL: EMPUJA EL SCROLL. La pista ya es una fila con
   overflow-x y scroll-snap, asi que arrastrarla con el dedo funciona sin
   esto. Lo unico que agrega este archivo es el avance solo y los botones.
   Si el archivo no carga, queda un carrusel que se maneja a mano.

   POR QUE EL AUTOPLAY SE FRENA TANTO. Un carrusel que se mueve solo compite
   con quien esta leyendo. Se para cuando:
   - el puntero esta encima o el foco esta adentro (alguien esta leyendo),
   - la pestaña no esta a la vista (no tiene sentido y gasta),
   - la seccion no esta en pantalla,
   - alguien arrastra la pista a mano,
   - el sistema pide menos movimiento: ahi directamente nunca arranca.

   Esa ultima es un requisito, no una cortesia: contenido que se mueve solo
   por mas de cinco segundos tiene que poder frenarse.

   VUELVE AL PRINCIPIO AL LLEGAR AL FINAL, pero solo el autoplay. Los botones
   no dan la vuelta: se apagan en las puntas, porque un boton encendido que
   te manda al otro extremo desorienta. */
(function () {
  'use strict';

  if (customElements.get('q-carousel')) return;

  var QUIETO = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : null;

  // Margen de tolerancia para decidir si el scroll llego a la punta. Los
  // navegadores devuelven fracciones de pixel y una comparacion exacta nunca
  // da verdadera.
  var BORDE = 2;

  class QCarousel extends HTMLElement {
    connectedCallback() {
      this.pista = this.querySelector('[data-car-track]');
      if (!this.pista) return;

      this.celdas = this.querySelectorAll('[data-car-cell]');
      this.prev = this.querySelector('[data-car-prev]');
      this.next = this.querySelector('[data-car-next]');
      this.quieto = false;

      var seg = parseFloat(this.getAttribute('data-interval')) || 2;
      this.espera = Math.max(1000, seg * 1000);
      this.autoplay = this.getAttribute('data-autoplay') === '1';

      this.armarBotones();
      this.armarPausas();
      this.marcarPuntas();

      this.pista.addEventListener('scroll', this.alScrollear.bind(this), { passive: true });

      if (this.autoplay) this.mirar();
    }

    // ---- botones ----

    armarBotones() {
      if (this.prev) {
        this.prev.hidden = false;
        this.prev.addEventListener('click', this.correr.bind(this, -1));
      }
      if (this.next) {
        this.next.hidden = false;
        this.next.addEventListener('click', this.correr.bind(this, 1));
      }
    }

    /* El paso es el ancho de una celda mas el hueco, medido de la celda real
       y no calculado de los settings: asi sigue siendo correcto con cualquier
       cantidad de columnas y en cualquier ancho de pantalla, sin que el JS
       tenga que enterarse del breakpoint. */
    paso() {
      if (!this.celdas.length) return this.pista.clientWidth;
      var a = this.celdas[0].getBoundingClientRect();
      if (this.celdas.length > 1) {
        return this.celdas[1].getBoundingClientRect().left - a.left;
      }
      return a.width;
    }

    correr(signo) {
      this.pista.scrollBy({
        left: this.paso() * signo,
        behavior: this.suave() ? 'smooth' : 'auto'
      });
    }

    suave() {
      return !(QUIETO && QUIETO.matches);
    }

    // ---- puntas ----

    finDeRecorrido() {
      return this.pista.scrollWidth - this.pista.clientWidth;
    }

    marcarPuntas() {
      var x = this.pista.scrollLeft;
      var fin = this.finDeRecorrido();
      // En lectura de derecha a izquierda scrollLeft es negativo: se compara
      // sobre el valor absoluto para no apagar los dos botones a la vez.
      var d = Math.abs(x);
      if (this.prev) this.prev.disabled = d <= BORDE;
      if (this.next) this.next.disabled = d >= fin - BORDE;
    }

    alScrollear() {
      this.marcarPuntas();
      // Arrastrar a mano corta el autoplay hasta que la persona suelte y pase
      // el intervalo completo: si no, el carrusel pelea contra el dedo.
      if (this.tiempo) {
        clearInterval(this.tiempo);
        this.tiempo = null;
        clearTimeout(this.retomar);
        this.retomar = setTimeout(this.arrancar.bind(this), this.espera);
      }
    }

    // ---- autoplay ----

    arrancar() {
      if (!this.autoplay || this.tiempo || this.quieto) return;
      if (QUIETO && QUIETO.matches) return;
      this.tiempo = setInterval(this.avanzar.bind(this), this.espera);
    }

    frenar() {
      clearInterval(this.tiempo);
      clearTimeout(this.retomar);
      this.tiempo = null;
    }

    avanzar() {
      var fin = this.finDeRecorrido();
      if (Math.abs(this.pista.scrollLeft) >= fin - BORDE) {
        this.pista.scrollTo({ left: 0, behavior: this.suave() ? 'smooth' : 'auto' });
        return;
      }
      this.correr(1);
    }

    armarPausas() {
      var pausar = function () {
        this.quieto = true;
        this.frenar();
      }.bind(this);

      var seguir = function () {
        this.quieto = false;
        this.arrancar();
      }.bind(this);

      this.addEventListener('pointerenter', pausar);
      this.addEventListener('pointerleave', seguir);
      this.addEventListener('focusin', pausar);
      this.addEventListener('focusout', seguir);

      // Una pestaña en segundo plano congela los temporizadores de forma
      // impredecible: mejor apagarlo a mano y volver a arrancar limpio.
      this.alCambiarPestana = function () {
        if (document.hidden) this.frenar();
        else if (this.aLaVista) this.arrancar();
      }.bind(this);
      document.addEventListener('visibilitychange', this.alCambiarPestana);
    }

    mirar() {
      if (!('IntersectionObserver' in window)) {
        this.aLaVista = true;
        this.arrancar();
        return;
      }
      this.ojo = new IntersectionObserver(
        function (entradas) {
          entradas.forEach(
            function (e) {
              this.aLaVista = e.isIntersecting;
              if (e.isIntersecting && !document.hidden) this.arrancar();
              else this.frenar();
            }.bind(this)
          );
        }.bind(this),
        { threshold: 0.2 }
      );
      this.ojo.observe(this);
    }

    disconnectedCallback() {
      this.frenar();
      if (this.ojo) this.ojo.disconnect();
      if (this.alCambiarPestana) {
        document.removeEventListener('visibilitychange', this.alCambiarPestana);
      }
    }
  }

  customElements.define('q-carousel', QCarousel);
})();
